import { format } from "date-fns/format";
import { constants } from "../constants";
import { getDate, getMinutes, setMinutes, addMinutes, setHours, endOfDay } from "date-fns";

export function getTeamsDateFormat(date: Date) {
    return format(date, constants.dateFormat);
}

export function getTeamsTimeFormat(date: Date) {
    return format(date, constants.timeFormat);
}

export function getDifferenceInHours(dateLeft: Date, dateRight: Date) {
    return dateLeft.getHours() - dateRight.getHours();
}

export function getDifferenceInMinutes(dateLeft: Date, dateRight: Date) {
    const diffInHours = getDifferenceInHours(dateLeft, dateRight);

    return diffInHours * 60 + dateLeft.getMinutes() - dateRight.getMinutes();
}

export function getMeetingMinTime(date: Date) {
    if (
        date.getFullYear() !== new Date().getFullYear() ||
        date.getMonth() !== new Date().getMonth() ||
        getDate(date) !== getDate(new Date())
    ) {
        return setHours(setMinutes(date, 0), 0);
    }

    // Temporarily hardcoded for quick development
    // TODO: Change to reflect step changes
    let minutes = getMinutes(new Date()) >= 30 ? 60 : 30;
    return setMinutes(new Date(), minutes);
}

export function getMeetingDefaultEndTime(date: Date) {
    return addMinutes(getMeetingMinTime(date), constants.defaultMeetingDurationInMinutes);
}

export function clearSeconds(date: Date) {
    date.setSeconds(0, 0);
    return date;
}

export function isSameDay(date1: Date, date2: Date) {
    return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
    );
}
